/* eslint-disable no-param-reassign */

import {
  modalTriggerSelectors as selectors,
  modalTriggerClasses as classes,
} from './config';

export default class ModalTriggers {
  constructor(container) {
    this.$container = container;

    // Main modal triggers
    this.desktopContainer = this.$container.querySelector(
      selectors.desktopContainer,
    );
    this.triggerContainer = this.desktopContainer.querySelector(
      selectors.triggerContainer,
    );
    this.triggers = [
      ...this.triggerContainer.querySelectorAll(selectors.triggers),
    ];

    // Modal triggers in dropdown
    this.dropdownContainer = this.$container.querySelector(
      selectors.dropdownContainer,
    );
    this.dropdownTrigger = this.dropdownContainer.querySelector(
      selectors.dropdownTrigger,
    );
    this.dropdown = this.dropdownContainer.querySelector(selectors.dropdown);
    if (!this.dropdown) {
      return;
    }

    this.dropdownTriggers = [
      ...this.dropdown.querySelectorAll(selectors.dropdownTriggers),
    ];
    this.dropdownCount = this.dropdownTrigger.querySelector(
      selectors.dropdownCount,
    );

    this.dropdownOverlay = this.dropdownContainer.querySelector(
      selectors.dropdownOverlay,
    );

    this.mount();
  }

  toggleDropdown() {
    this.dropdown.classList.toggle(classes.dropdownVisible);
  }

  closeDropdown() {
    if (!this.dropdown.classList.contains(classes.dropdownVisible)) {
      return;
    }

    this.dropdown.classList.remove(classes.dropdownVisible);
  }

  events() {
    const triggerContainerOffset = this.triggerContainer.offsetTop;
    let indexToStartHidingTriggers = null;

    this.triggers.some((triggerEl, index) => {
      const { offsetTop } = triggerEl;

      if (offsetTop <= triggerContainerOffset) return false;

      indexToStartHidingTriggers = index;
      return true;
    });

    const triggersToHide = this.triggers.slice(indexToStartHidingTriggers);
    const dropdownTriggersToHide = this.dropdownTriggers?.slice(0, indexToStartHidingTriggers) || [];
    const triggersToShow = this.triggers.slice(0, indexToStartHidingTriggers);
    const dropdownTriggersToShow = this.dropdownTriggers?.slice(indexToStartHidingTriggers) || [];

    triggersToHide.forEach((triggerEl) => (triggerEl.ariaHidden = true));
    triggersToShow.forEach((triggerEl) => (triggerEl.ariaHidden = false));

    dropdownTriggersToHide.forEach((triggerEl) => triggerEl.classList.add(classes.buttonHidden));
    dropdownTriggersToShow.forEach((triggerEl) => triggerEl.classList.remove(classes.buttonHidden));

    let moreFiltersCount = 0;

    triggersToHide.forEach((triggerEl) => {
      const filterCount = triggerEl.querySelector(
        `.${selectors.filterCount}`,
      ).innerText;
      moreFiltersCount += Number(filterCount);
    });

    if (this.dropdownCount) {
      this.updateDropdownCount(moreFiltersCount);
    }
  }

  updateDropdownCount(count) {
    const hideCount = count === 0;

    this.dropdownCount.classList.toggle(classes.countHidden, hideCount);
    this.dropdownCount.innerText = count;
  }

  recalculateMoreFilterCount() {
    const buttons = this.dropdown.querySelectorAll(selectors.visibleButtons);
    let dropdownCount = 0;

    setTimeout(() => {
      buttons.forEach((button) => {
        const activeFilterCount = button.querySelector(
          `.${selectors.filterCount}`,
        ).innerHTML;
        dropdownCount += Number(activeFilterCount);
      });

      this.updateDropdownCount(dropdownCount);
    }, 200);
  }

  attachListeners() {
    window.addEventListener('calculateMoreFiltersCountJs', () => this.recalculateMoreFilterCount());

    this.dropdownTrigger.addEventListener('click', () => this.toggleDropdown());

    // Closes the dropdowns
    this.dropdownOverlay.addEventListener('click', () => this.closeDropdown());
    this.dropdown.addEventListener('click', () => this.closeDropdown());
  }

  mount() {
    this.attachListeners();
  }
}
